import { conf } from "../config/config"

export const CURRENCY_EURO = 'euro'
export const CURRENCY_USD = 'usd'

export const AUTH_TOKEN = 'admin-auth-token'
export const SESSION_TOKEN = 'admin-session-token'
export const USER_UUID = 'admin-user-uuid'
export const DEMO_MODE = 'demo'
export const DEMO_TOKEN  = conf['token']

export const urlAccount = '/account'
export const urlBalance = '/balance'
export const urlAd = '/ad'

export const boolean = (str) => {
    if(str==="true"){
        return true
    }
    return false
}
